import { render, staticRenderFns } from "./CostHistorys.vue?vue&type=template&id=535f5665&scoped=true&"
import script from "./CostHistorys.vue?vue&type=script&lang=js&"
export * from "./CostHistorys.vue?vue&type=script&lang=js&"
import style0 from "./CostHistorys.vue?vue&type=style&index=0&id=535f5665&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535f5665",
  null
  
)

export default component.exports